import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useAppConfig } from "@limitless/common/hooks/app-config/AppConfigContext";
import { useAuthenticationContext } from "../../../expert/hooks/authentication/AuthenticationContext";
import { createMutationHeaders } from "../../utils/SecurePlatformAPIUtils";
import { useExpertProfileContext } from "../../../expert";
// Set the default state values for each context
export const RestrictedAppConfigContext = /*#__PURE__*/createContext({});

//probably shouldnt be a context, but if not, how?
export const RestrictedAppConfigContextProvider = ({
  children
}) => {
  const hook = useRestrictedAppConfig();
  return /*#__PURE__*/React.createElement(RestrictedAppConfigContext.Provider, {
    value: hook
  }, children);
};
export const useRestrictedAppConfigContext = () => {
  return useContext(RestrictedAppConfigContext);
};
RestrictedAppConfigContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};
const useRestrictedAppConfig = () => {
  const {
    isAuthenticated
  } = useAuthenticationContext();
  const {
    loadRestrictedAppConfig,
    config
  } = useAppConfig();
  const {
    canUserAccess
  } = useExpertProfileContext();
  React.useEffect(() => {
    //wait until we're finished loading public config and are authenticated
    //we also need the plat_config_edit policy to access restricted config
    if (isAuthenticated && !config.loading && canUserAccess("plat_config_edit")) {
      loadRestrictedAppConfig(createMutationHeaders().headers);
    }
  }, [isAuthenticated, config.loading]);
  return {};
};